import React from 'react';

import { Icon } from 'common/icon';
import { Flex } from 'common/flex';
import { PADDING } from 'constants/sizes';

import { IButton } from './types';
import { StyledButton } from './styles';

const TEXT_PADDING = `0 ${PADDING.default}`;
const ICON_PADDING = `0 ${PADDING.small}`;

export const Button = ({
  icon,
  title,
  style,
  variant,
  palette,
  padding,
  children,
  innerRef,
  type = 'button',
  reversed = false,
  ...props
}: React.PropsWithChildren<IButton>) => {
  const defaultPadding = React.useMemo(() => {
    if (padding) {
      switch (padding) {
        case 'icon':
          return ICON_PADDING;
        case 'text':
          return TEXT_PADDING;
        case 'none':
          return 0;
      }
    }

    if (icon && !title) {
      return ICON_PADDING;
    }

    return TEXT_PADDING;
  }, [icon, title, padding]);

  return (
    <StyledButton
      type={type}
      ref={innerRef}
      variant={variant}
      palette={palette}
      style={{ padding: defaultPadding, ...style }}
      {...props}
    >
      <Flex
        gap="8px"
        alignItems="center"
        justifyContent="center"
        flexDirection={reversed ? 'row-reverse' : 'row'}
      >
        {children ? (
          children
        ) : (
          <>
            {icon && <Icon icon={icon} />}
            {title && <h3>{title}</h3>}
          </>
        )}
      </Flex>
    </StyledButton>
  );
};
